/*
 * Enum values for calculation states.
 */
const CALCULATION_STATES = {
    noOperation: -1,
    success: 0,
    pending: 1,
    error: 2,
}

export default CALCULATION_STATES
